import React from 'react'

const testimonials = [
  {
    quote: 'Papreja helped us turn a complicated idea into a product our customers understood immediately. The whole process felt clear and collaborative.',
    name: 'Vikas Bhatt',
    role: 'Founder, Victorian Utility Pvt. Ltd.',
    initials: 'VB',
    color: 'bg-cyan-400 text-[#071a3d]',
  },
  {
    quote: 'We finally have a website that feels like our business. It is faster, easier to manage, and our team is proud to share it.',
    name: 'Arvind Kumar',
    role: 'Director, Accounts & Finance, Department of Finance',
    initials: 'AK',
    color: 'bg-blue-500 text-white',
  },
  {
    quote: 'The support has been exceptional. They explain the technical details clearly and always find a practical way forward.',
    name: 'Sajjan Kumar',
    role: 'Operations Lead, Talentiser Pvt. Ltd.',
    initials: 'SK',
    color: 'bg-indigo-500 text-white',
  },
]

function Testimonials() {
  return (
    <section className="relative overflow-hidden bg-white py-16 dark:bg-slate-900 sm:py-20">
      <div className="absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-cyan-100/60 blur-3xl dark:bg-cyan-950/30" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="flex flex-col justify-between gap-5 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-600 dark:text-cyan-400">Client stories</p>
            <h2 className="mt-4 text-4xl font-black tracking-tight text-slate-900 dark:text-white sm:text-5xl">
              Good work feels better together.
            </h2>
          </div>
          <p className="max-w-xs text-sm leading-6 text-slate-500 dark:text-slate-400">
            Real partnerships. Clear communication. Digital work that earns its place in the real world.
          </p>
        </div>

        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          {testimonials.map((testimonial) => (
            <article
              key={testimonial.name}
              className="group flex flex-col rounded-2xl border border-slate-200 bg-slate-50 p-6 transition duration-300 hover:-translate-y-1 hover:border-cyan-300 hover:bg-white hover:shadow-xl hover:shadow-cyan-900/10 dark:border-slate-800 dark:bg-slate-950 dark:hover:border-cyan-700 dark:hover:bg-slate-900"
            >
              <div className="flex items-center justify-between">
                <span className="text-4xl font-black leading-none text-cyan-400">&ldquo;</span>
                <span className="text-sm tracking-[0.2em] text-amber-400" aria-label="5 out of 5 stars">★★★★★</span>
              </div>
              <blockquote className="mt-5 flex-1 text-base leading-7 text-slate-700 dark:text-slate-300">
                {testimonial.quote}
              </blockquote>
              <footer className="mt-8 flex items-center gap-3 border-t border-slate-200 pt-5 dark:border-slate-800">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-xs font-black ${testimonial.color}`}>
                  {testimonial.initials}
                </span>
                <span>
                  <cite className="block text-sm font-bold not-italic text-slate-900 dark:text-white">{testimonial.name}</cite>
                  <span className="mt-0.5 block text-xs text-slate-500 dark:text-slate-400">{testimonial.role}</span>
                </span>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials
